import React from "react";
import { Link } from "react-router-dom";

export default function RiskMitigation(props) {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6 text-yellow-500">
        Risk Mitigation
      </h1>

      <div className="space-y-5">
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-1">
            Risk Mitigation Guidelines for safeguarding and ensuring safety of
            children participants are placed at{" "}
            <Link
              to="/csppolicy/annexure1"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="text-yellow-500 hover:underline"
            >
              Annexure-1
            </Link>
            . These shall be followed by Slum Soccer (SS/KVS) at organizational
            level and by SS/KVS staff in their individual capacities before and
            during conducting activity involving children.
          </span>
        </div>
      </div>
    </div>
  );
}
